import { createRoute } from '@tanstack/react-router'
import { lazy, Suspense } from 'react'
import { Center, Spinner } from '@chakra-ui/react'
import { authenticatedRoute } from '../_authenticated'

const QuizOverview = lazy(() => import('@/pages/quizzes').then(m => ({ default: m.QuizOverview })))
const QuizTaking = lazy(() => import('@/pages/quizzes/QuizTaking'))

function QuizOverviewWrapper() {
  return (
    <Suspense fallback={<Center h="100vh"><Spinner size="lg" color="purple.500" /></Center>}>
      <QuizOverview />
    </Suspense>
  )
}

function QuizTakingWrapper() {
  return (
    <Suspense fallback={<Center h="100vh"><Spinner size="lg" color="purple.500" /></Center>}>
      <QuizTaking />
    </Suspense>
  )
}

export const quizzesIndexRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/quizzes',
  component: QuizOverviewWrapper,
})

export const quizRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/quizzes/$quizKey',
  component: QuizTakingWrapper,
})
